export default {
  CARFAX: 'carfax',
  LENDO: 'lendo',
  RESERVATION_B2C: 'reservation_b2c'
}
